
export { default as getProductDetialHref } from "./getProductDetialHref"
export { default as getWebpUrl } from "./getWebpUrl"